import {
    ViewDataRange,
    ViewEvaluationRange,
    WpDisplayConfig,
} from '../../winning-percentage/core';
import { Sort, SortDirection } from '../model/sort-direction.model';

export interface MainState {
    pending: {
        reload?: boolean;
        reset?: boolean;
    };
    config?: WpDisplayConfig;
    dataRanges?: ViewDataRange[];
    selectedDataRangeId?: number;
    evalRanges?: ViewEvaluationRange[];
    selectedEvalRangeId?: number;
    selectedDrillPathId?: string;
    period?: {
        start: Date;
        end: Date;
        createdOn: Date;
    };
    hasData?: boolean;
    sortOptions?: Sort;
    otherRows?: any[];
}

export const defaultState = (): MainState => ({
    pending: {},
    sortOptions: {
        columnId: 'WINNING_PERCENTAGE',
        order: SortDirection.DESC,
    },
});
